import React from "react";
import "./LpHeader.css";
import thumbsUp from "./../../../vid_img/thumbsUpImg.png";
import uaeFlag from "./../../../vid_img/Countries_Flag/UAE.png";
import bahrainFlag from "./../../../vid_img/Countries_Flag/Baharain.png";
import saudiFlag from "./../../../vid_img/Countries_Flag/Saudi Arabia.png";
import qatarFlag from "./../../../vid_img/Countries_Flag/Qatar.png";
import kuwaitFlag from "./../../../vid_img/Countries_Flag/Kuwait.png";
import malaysiaFlag from "./../../../vid_img/Countries_Flag/Malaysia.png";
import google from "./../../../vid_img/google.png";
import star from "./../../../vid_img/star.png";
import { FaWhatsapp } from "react-icons/fa";

const LpHeader = () => {
  return (
    <div className="lpHeader-container" id="home">
      <div className="lpHeader-content">
        <div className="lpHeader-item">
          <h5>Welcome to GoodwayAttestation</h5>
        </div>
        <h2>
          <span> Embassy Attestation and apostille in Bangalore, Karnataka </span> get your documents in just 3 days
        </h2>
        <p>
          We handle educational, personal, and commercial documents with
          complete accuracy and timely delivery—so you can focus on your travel,
          job, or study plans without delays.
        </p>
        <div className="lpHeader-buttonContainer">
          <a href="tel:9148889666 ">
            <button>Best Price</button>
          </a>
          <a href="tel:9148889444">
            {" "}
            <button>
              <FaWhatsapp className="lpMenu-ico" />
              Call Us Now
            </button>
          </a>
        </div>
      </div>
      <div className="lpHeader-content">
        <div className="lpHeader-key">
          Trusted By <b>25000+</b>
        </div>
        <div className="lpHeader-key">
          Experience <b>16 years</b>
        </div>
        <div className="lpHeader-key">
          Document Processed <b>4 Lakh+</b>
        </div>
        <div className="lpHeader-key">
          <b>Government </b>Approved
        </div>
        <div className="lpHeader-imgContainer">
          <div className="lpHeader-countries" id="lpHeader-countries1">
            <img src={uaeFlag} alt="uaeFlag" />
          </div>
          <div className="lpHeader-countries" id="lpHeader-countries2">
            <img src={bahrainFlag} alt="bahrainFlag" />
          </div>
          <div className="lpHeader-countries" id="lpHeader-countries3">
            <img src={saudiFlag} alt="saudiFlag" />
          </div>
          <div className="lpHeader-countries" id="lpHeader-countries4">
            <img src={qatarFlag} alt="qatarFlag" />
          </div>
          <div className="lpHeader-countries" id="lpHeader-countries5">
            <img src={kuwaitFlag} alt="kuwaitFlag" />
          </div>
          <div className="lpHeader-countries" id="lpHeader-countries6">
            <img src={malaysiaFlag} alt="malaysiaFlag" />
          </div>

          <div className="lpHeader-imgContent">
            <div className="lpHeader-imgItem">
              <img src={thumbsUp} alt="thumbs Up" />
            </div>
          </div>
        </div>
      </div>
      <div className="lpHeader-gRatingContainer">
        <div className="lpHeader-gRatingContent">
          <img src={google} alt="google" />
        </div>
        <div className="lpHeader-gRatingContent">
          <h4>Google Rating 4.9</h4>
          <img src={star} alt="star" />
        </div>
      </div>
    </div>
  );
};

export default LpHeader;
